import { render, staticRenderFns } from "./ViewSpecificTypeExpenseDetails.vue?vue&type=template&id=a1f8dc8a"
import script from "./ViewSpecificTypeExpenseDetails.vue?vue&type=script&lang=js"
export * from "./ViewSpecificTypeExpenseDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports